import NoteStore from "../store/index";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_NOTES_CACHE_END_TIME_IN_STORE', function setNotesCacheEndTimeInStore(notesCacheEndTime: Moment) {
    NoteStore().notesCacheEndTime = notesCacheEndTime;
});
